export const sortableDateTimeFormat = 'YYYY-MM-DD HH:mm:ss';
export const compactDateTimeFormat = 'HH:mm:ss | DD-MM-YY';
export const shortDateTimeFormat = 'DD MMM HH:mm';
export const shortDateTimeFormatSeconds = 'DD MMM HH:mm:ss';
export const longDateTimeFormat = 'HH:mm:ss, DD MMM YYYY';
export const longDateFormat = 'DD-MM-YYYY'
export const shortDateFormat = 'DD-MM-YY';
export const timeFormat = 'HH:mm';
export const timeFormatSeconds = 'HH:mm:ss';
export const fullDateTimeFormat = 'DD-MM-YYYY HH:mm:ss';